<template>
  <v-btn @click="exportDataToExcel" color="green" dark outlined>
    <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel</v-btn
  >
</template>

<script>
import XLSX from 'xlsx-js-style'

export default {
  props: {
    data: Array,
    exam: Object
  },
  data() {
    return {
      loading: false,
      subjectHeaders: [],
      marks: [],
      json_fields: {
        Lớp: 'class',
        GVGD: 'teacher',
        'Số HS': 'totalMarks',
        VT: 'absent',
        Max: 'max',
        Min: 'min',
        TB: 'average',
        'Xếp thứ': 'rank'
      }
    }
  },
  methods: {
    async exportDataToExcel() {
      this.loading = true

      const ws = XLSX.utils.aoa_to_sheet([])

      // Calculate total number of columns based on all subjects' headers
      const totalColumns =
        this.data.reduce((sum, subject) => {
          return sum + Object.keys(this.json_fields).length + 1 // 1 column gap between subjects
        }, 0) - 1 // remove the extra gap at the end

      // Add header "A" in row 1
      XLSX.utils.sheet_add_aoa(ws, [['TRƯỜNG THPT Lý Thái Tổ']], { origin: { r: 0, c: 0 } })
      ws['!merges'] = ws['!merges'] || []
      ws['!merges'].push({
        s: { r: 0, c: 0 },
        e: { r: 0, c: totalColumns - 1 }
      })
      ws['A1'].s = {
        font: { bold: true },
        alignment: { horizontal: 'left' }
      }

      // Add header "B" in row 2
      XLSX.utils.sheet_add_aoa(ws, [[`BẢNG THỐNG KÊ KẾT QUẢ ${this.exam.name.toUpperCase()}`]], {
        origin: { r: 1, c: 0 }
      })
      ws['!merges'].push({
        s: { r: 1, c: 0 },
        e: { r: 1, c: totalColumns - 1 }
      })
      ws['A2'].s = {
        font: { bold: true },
        alignment: { horizontal: 'center' }
      }

      let currentCol = 0

      this.data.forEach((subject, index) => {
        const { subjectGroup, classReports } = subject
        const headerLength = Object.keys(this.json_fields).length

        // Set the subjectGroup header in row 3
        XLSX.utils.sheet_add_aoa(ws, [[subjectGroup]], {
          origin: { r: 2, c: currentCol }
        })

        // Merge subject header cells
        ws['!merges'].push({
          s: { r: 2, c: currentCol },
          e: { r: 2, c: currentCol + headerLength - 1 }
        })

        // Initialize and style each cell in the merged range to ensure a border is applied
        for (let i = 0; i < headerLength; i++) {
          const cellAddress = XLSX.utils.encode_cell({ r: 2, c: currentCol + i })
          ws[cellAddress] = ws[cellAddress] || {}
          ws[cellAddress].v = subjectGroup
          ws[cellAddress].s = {
            font: { bold: true },
            alignment: { horizontal: 'center', vertical: 'center' },
            border: {
              top: { style: 'medium' },
              bottom: { style: 'medium' },
              left: i === 0 ? { style: 'medium' } : undefined,
              right: i === headerLength - 1 ? { style: 'medium' } : undefined
            }
          }
        }

        // Add headers for the table in row 4
        const headers = Object.keys(this.json_fields)
        XLSX.utils.sheet_add_aoa(ws, [headers], { origin: { r: 3, c: currentCol } })

        // Apply header styling with borders
        headers.forEach((header, idx) => {
          const cell = ws[XLSX.utils.encode_cell({ r: 3, c: currentCol + idx })]
          cell.s = {
            font: { bold: true },
            alignment: { horizontal: 'center' },
            border: {
              top: { style: 'medium' },
              bottom: { style: 'medium' },
              left: { style: 'medium' },
              right: { style: 'medium' }
            }
          }
        })

        // Add the class reports for each subject starting from row 5
        classReports.forEach((report, rowIdx) => {
          const row = headers.map(header => report[this.json_fields[header]])
          XLSX.utils.sheet_add_aoa(ws, [row], { origin: { r: 4 + rowIdx, c: currentCol } })

          // Apply border styling to each cell in the row
          row.forEach((_, colIdx) => {
            const cell = ws[XLSX.utils.encode_cell({ r: 4 + rowIdx, c: currentCol + colIdx })]
            cell.s = {
              border: {
                top: { style: 'medium' },
                bottom: { style: 'medium' },
                left: { style: 'medium' },
                right: { style: 'medium' }
              }
            }
          })
        })

        // Update current column position for the next subject table
        currentCol += headers.length + 1 // 1 column gap
      })

      // Create a workbook and add the worksheet
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'Report')

      // Export to Excel
      XLSX.writeFile(wb, `Thống kê.xlsx`)
      this.loading = false
    }
  }
}
</script>
